jQuery(function ($) {
  // Accueil
  $(".slider-accueil").each(function (index) {
    $(this).slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      cssEase: "linear",
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false,
    });
  });
  // Modulaire
  $(".slider-galerie").each(function (index) {
    $(this).slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      cssEase: "linear",
      dots: false,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnFocus: false,
      pauseOnHover: false,
    });
  });
});
